/**
 * Knitwear silhouettes: sweater, cardigan, pullover.
 */
import { OUTLINE_ATTRS, DETAIL_ATTRS, DETAIL_FILLED_ATTRS, STITCH_ATTRS } from "./_attrs.js";
import { ribBand, placketButtons, neckLabel } from "./_primitives.js";

import type { FlatView } from "../flat-svg.js";

/* ── Sweater (crew neck, long sleeves, rib trim at all openings) ──── */
export function sweaterFlat(view: FlatView): string {
  const neckDip = view === "front" ? 108 : 96;
  return `<g>
  <path ${OUTLINE_ATTRS} d="M 158 92 L 102 110 L 58 240 L 40 346 L 96 360 L 116 274 L 130 190 L 130 418 L 270 418 L 270 190 L 284 274 L 304 360 L 360 346 L 342 240 L 298 110 L 242 92 Q 200 ${neckDip - 20} 158 92 Z"/>
  <path ${DETAIL_ATTRS} d="M 158 92 Q 200 ${neckDip} 242 92"/>
  <path ${STITCH_ATTRS} d="M 161 97 Q 200 ${neckDip + 6} 239 97"/>
  ${ribBand(418, 130, 270, 14)}
  <path ${DETAIL_FILLED_ATTRS} d="M 40 346 L 96 360 L 90 382 L 34 368 Z"/>
  <path ${DETAIL_FILLED_ATTRS} d="M 360 346 L 304 360 L 310 382 L 366 368 Z"/>
  <path ${STITCH_ATTRS} d="M 102 112 Q 120 150 130 190"/>
  <path ${STITCH_ATTRS} d="M 298 112 Q 280 150 270 190"/>
  ${
    view === "front"
      ? `<rect x="186" y="98" width="28" height="12" rx="1.5" ${DETAIL_ATTRS}/>`
      : `<path ${STITCH_ATTRS} d="M 138 134 L 262 134"/>
  ${neckLabel(200, 92)}`
  }
</g>`;
}

/* ── Cardigan (open front, buttons, V-neckline) ──────────────────── */
export function cardiganFlat(view: FlatView): string {
  return `<g>
  <path ${OUTLINE_ATTRS} d="M 162 88 L 104 106 L 60 236 L 42 342 L 98 356 L 118 268 L 130 184 L 130 418 L 270 418 L 270 184 L 282 268 L 302 356 L 358 342 L 340 236 L 296 106 L 238 88 Q 200 76 162 88 Z"/>
  ${ribBand(418, 130, 270, 14)}
  <path ${DETAIL_FILLED_ATTRS} d="M 42 342 L 98 356 L 92 378 L 36 364 Z"/>
  <path ${DETAIL_FILLED_ATTRS} d="M 358 342 L 302 356 L 308 378 L 364 364 Z"/>
  <path ${STITCH_ATTRS} d="M 104 108 Q 120 146 130 184"/>
  <path ${STITCH_ATTRS} d="M 296 108 Q 280 146 270 184"/>
  ${
    view === "front"
      ? `<path ${DETAIL_ATTRS} d="M 162 88 Q 200 76 238 88"/>
  <path ${DETAIL_ATTRS} d="M 176 88 L 188 200"/>
  <path ${DETAIL_ATTRS} d="M 224 88 L 212 200"/>
  <path ${DETAIL_ATTRS} d="M 188 200 L 188 414"/>
  <path ${DETAIL_ATTRS} d="M 212 200 L 212 414"/>
  <path ${STITCH_ATTRS} d="M 192 204 L 192 412"/>
  <path ${STITCH_ATTRS} d="M 208 204 L 208 412"/>
  ${placketButtons(200, [218, 264, 310, 356])}`
      : `<path ${DETAIL_ATTRS} d="M 162 88 Q 200 76 238 88"/>
  <path ${STITCH_ATTRS} d="M 138 130 L 262 130"/>
  ${neckLabel(200, 88)}`
  }
</g>`;
}

/* ── Pullover (V-neck, long sleeves, rib trim) ────────────────────── */
export function pulloverFlat(view: FlatView): string {
  const neckDip = view === "front" ? 136 : 96;
  return `<g>
  <path ${OUTLINE_ATTRS} d="M 158 90 L 102 108 L 58 238 L 40 344 L 96 358 L 116 272 L 130 188 L 130 418 L 270 418 L 270 188 L 284 272 L 304 358 L 360 344 L 342 238 L 298 108 L 242 90 Q 200 ${neckDip - 24} 158 90 Z"/>
  ${
    view === "front"
      ? `<path ${DETAIL_ATTRS} d="M 166 88 L 200 ${neckDip} L 234 88"/>
  <path ${STITCH_ATTRS} d="M 169 93 L 200 ${neckDip + 6} L 231 93"/>`
      : `<path ${DETAIL_ATTRS} d="M 158 90 Q 200 ${neckDip} 242 90"/>
  <path ${STITCH_ATTRS} d="M 161 95 Q 200 ${neckDip + 6} 239 95"/>
  <path ${STITCH_ATTRS} d="M 138 132 L 262 132"/>
  ${neckLabel(200, 90)}`
  }
  ${ribBand(418, 130, 270, 14)}
  <path ${DETAIL_FILLED_ATTRS} d="M 40 344 L 96 358 L 90 380 L 34 366 Z"/>
  <path ${DETAIL_FILLED_ATTRS} d="M 360 344 L 304 358 L 310 380 L 366 366 Z"/>
  <path ${STITCH_ATTRS} d="M 102 110 Q 120 148 130 188"/>
  <path ${STITCH_ATTRS} d="M 298 110 Q 280 148 270 188"/>
</g>`;
}
